import React from 'react';
import styles from './PrimaryButton.module.css';

export const PrimaryButton = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement>
>(({ className, ...rest }, ref) => (
  <button
    ref={ref}
    // Unwired a11y placeholder; a consumer-passed aria-label (Apple Pay express
    // button) overrides it. Backlog: docs/a11y-maintenance-backlog.md#primarybutton
    aria-label=""
    {...rest}
    className={[styles.root, className].filter(Boolean).join(' ')}
  />
));

PrimaryButton.displayName = 'PrimaryButton';
